export const MoneyField = function(props) {
    if(props.currency === 'EUR') {
        return '€' + parseFloat(props.amount).toFixed(2);
    }
    else if(props.currency === 'USD') {
        return '$' + parseFloat(props.amount).toFixed(2);
    }

    return 0;
};